<template>
  <BaseSelect v-model="valueExistsInputReader" :options="selectOptions" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseSelect from "../../../../components/BaseSelect.vue";
import { EMPTY_VALUE_PLACEHOLDER } from "../../service.genericTable";
import { ValueExistsFilterType } from "../../type.genericTableQuery";
const { t } = useI18n();
const valueExistsFilter = defineModel<ValueExistsFilterType>({ required: true });

const selectOptions = [
  { value: EMPTY_VALUE_PLACEHOLDER, label: t("genericTable.valueExistsFilter.all") },
  { value: true, label: t("genericTable.valueExistsFilter.yes") },
  { value: false, label: t("genericTable.valueExistsFilter.no") },
];

const valueExistsInputReader = computed<boolean | typeof EMPTY_VALUE_PLACEHOLDER>({
  get: () => (valueExistsFilter.value.value === undefined ? EMPTY_VALUE_PLACEHOLDER : valueExistsFilter.value.value),
  set: (val) => {
    valueExistsFilter.value.value = val === EMPTY_VALUE_PLACEHOLDER ? undefined : val;
  },
});
</script>
